'use client'
import React from 'react'
import { Grid, Flex, Text, Box, Button, Tabs, rem, Table, ActionIcon, NativeSelect, Accordion, Badge } from '@mantine/core';
import SignUpForm from '@components/SignUpForm';

const groceries = [
  {
    value: 'What is WeList?',
    description:
      'WeList is a cloud based platform for Real Estate Agencies that allows them to operate and market their business.',
  },
  {
    value: 'What are the Main Functions of WeList',
    description:
      'WeList main functions are: Digital Marketing both websites and social marketing, Back Office, Lead management, Data Management, Agent Management, Translations and more.',
  },
  {
    value: 'What AI is in WeList?',
    description:
      'WeList uses AI to help reduce a lot of basic and repetitive tasks. AI helps write property descriptions, and generate social media content. You’ll find AI data input assistants filling forms based on free format text. AI handles your translations for you. AI examines incoming leads and helps rank them and scan for scams or invalid Leads. It will help you locate alternative properties for client requests.',
  },
  {
    value: 'What Subscriptions are available?',
    description:
      'There are 2 basic subscriptions and then there’s the most popular Combo pack. The two subscriptions available are WeList - Sites and WeList - Social both offer the back office they differ in what they produce, as the names suggests Sites creates web sites, and Social creates social posts. The combo pack uses a common back office to produce both websites and social media posts.',
  },
  {
    value: 'How much does WeList Cost?',
    description:
      'Subscriptions start at 4,888 THB/Month, depending on the setup and functionalities you need. Be sure to check our pricing module for up to date pricing.',
  },
  {
    value: 'Is there anything to pay on top of the subscription?',
    description:
      'Only if you need something extra that is not included in your current package. We try to keep the costs down by not selling more than you need. Every Subscription comes with one social user who can post to their social channels. If you want to post to X, then there’s a 200 THB/Month charge and if you want Social User seats for your agents, those are 200 THB/Month.  Be sure to check our pricing module for any updates on pricing. If you want additional websites, they are 2,000 THB per Month.',
  },
  {
    value: 'What Social Platforms can I post to with WeList?',
    description:
      'Facebook (Pages only), LinkedIn, Instagram, Google MyBusiness, Threads, X (additional cost). More platforms are coming in the future.',
  },
  {
    value: 'Why does X (Twitter) cost extra?',
    description:
      'X (formerly Twitter) API is unfortunately not for free.',
  },
  {
    value: 'Can I post video content on social media?',
    description:
      'At this time you cannot upload videos, but you can use Youtube Links to your videos in social posts.',
  },
  {
    value: 'Which Web portals can WeList feed?',
    description:
      'Proppit, which includes: DotProperty, Thailand-Property, Trovit, Mitula, Nestoria and Hipflat. Other Portals include: Nestopa and PropertyHub (more coming in the future)',
  },
  {
    value: 'Can I customize my web site?',
    description:
      'Your web site is “Configurable” meaning that you can select your colours, and control layout of pages. You can have your own banner too.  If you need customization beyond that, our development team can provide that service and an additional cost.',
  },
  {
    value: 'Can I transfer my existing listings into WeList?',
    description:
      'If your listings are in Proppit, we can import them into WeList. If you are an iList/iConnect user we can import daily updates. Depending how your listings are stored in databases or websites, our development team may be able to import them into WeList as an additional service.',
  },
  {
    value: 'How do I pay my subscription?',
    description:
      'Subscriptions are billed at the end of each month and payable in 7 days. You can pay by bank transfer.',
  },
  {
    value: 'Can I cancel my subscription?',
    description:
      'Yes. You can cancel at any time. We will cease billing. We do not offer prorated refunds.',
  },
  {
    value: 'How many agents can I have?',
    description:
      'While there’s no set limit to the number of agents you can have using WeList, they do need to be legitimately part of your organization. We reserve the right to cap the number of agents if there is abuse of this policy.',
  },
  {
    value: 'Why would I want multiple websites?',
    description:
      'The ability to create additional web sites on the subsets of your listings exists to allow you to create niche sites, for example just homes over 20M baht, or sites for your agents to help provide value added and increase agent retention. Additional sites are 2,000 THB/Month.',
  },
  {
    value: 'Does WeList support short-term rental management?',
    description:
      'No, WeList, understands rentals as monthly leases and can remind you when rentals are coming back on the market. But, there’s no check-in, check-out, calendars or any such property management features.',
  },
  {
    value: 'How many photos can I have on my listings?',
    description:
      'There’s really no fixed number, but we recommend at least 6 and at most 40.',
  },
  {
    value: 'Can Agents see all the agency listings and leads?',
    description:
      "Only if you allow them. WeList gives you a wide range of controls — you can set who can access what. We provide a set of predefined access levels such as Agency Owner, Office Admin, and Agent, which you can fine-tune or customize further by creating your own.",
  },
  {
    value: 'Does WeList support maps?',
    description:
      "Yes, your website can show properties on a map. You can decide whether to display exact location or approximate location of a listing (or don't display it at all). You can also locate alternate properties in the back-office using a map area.",
  },
  {
    value: 'How does LINE work with WeList?',
    description:
      "LINE is a very popular way for people to communicate and we know how convenient that is. We’ve integrated LINE into both the websites and the back-office. On the website, visitors can contact you directly via LINE (and WhatsApp) with a press of a button. In the back-office LINE is used for notifications. You can set up groups to receive notifications. Like you can set up a group for your agents to be notified of new listings added to the system. Your agents can get LINE notifications when a new lead is assigned to them. WeList keeps the communications flowing.",
  },
  {
    value: 'How long does it take to get up and running?',
    description:
      "Typically your user account can be set up next business day. It takes a few days for support to work with you to set up your settings in the system. Typically “Onboarding” can be complete in one to two weeks.",
  },
  {
    value: 'If I leave WeList, what happens to my Listings?',
    description:
      "We’d be sad to see you go. But rest assured that if you go, you go with all your data. Data is readably available in spreadsheets and image folders. You can download these at any time you want, even if you’re not leaving.",
  },
  {
    value: 'How can I prevent agents from leaving with listings?',
    description:
      "That’s a problem for many agencies. While we can’t control what “cuff records” are kept off-line. We do restrict who has access to the data exports. All modifications to listings are logged in the event that agents attempt to overwrite critical data, the original data can be recovered.",
  },
  {
    value: 'Is there a limit on how many social posts I can do in a day?',
    description:
      "WeList does not limit you, but your social platform may ban you if they feel you are spamming. You should check  the posting policies of every platform you target.",
  },
  {
    value: 'Can I control what my Social Posts look like?',
    description:
      "Yes. You can use WeList standard formats, or if you prefer, you can design custom templates that will give you full control of what information and what format appears in your social posts.",
  },
  {
    value: 'Can I have my website multilingual?',
    description:
      "Yes. That’s a core function of WeList. It transparently translates all your web content to English, Thai, Chinese and Russian. There’s nothing for you to do, it's all automatic. You can decide which languages you want when you are setting up your account with support.",
  },
  {
    value: 'Can I add more languages?',
    description:
      "Yes, as an additional service we will consider adding more languages on a case-by-case basis.",
  },
  {
    value: 'What languages does WeList support?',
    description:
      "English, Thai, Chinese and Russian",
  },
  {
    value: 'What training is available?',
    description:
      "During the onboarding process, support will train your trainer. We do not currently offer formal training sessions. We are growing a library of how-to videos.",
  },
  {
    value: 'What support is available?',
    description:
      "We offer support via chat and email. We typically get back to you the next business day",
  },
  {
    value: 'Can I post in different languages?',
    description:
      "Yes, We currently support posting in English, Thai and Chinese and also bilingual posts that are a combination of any two of the above languages.",
  },
  {
    value: 'Can I get a refund for unused subscriptions?',
    description:
      "Unfortunately not. Just let us know when you want to stop and we will cease billing. We cannot issue refunds.",
  },
  {
    value: 'Are your websites mobile friendly?',
    description:
      "Absolutely! Not only are your sites “Mobile Friendly” they are “Mobile First” meaning they are designed first to work on mobile platforms then they are adapted to work on PCs.",
  },
  {
    value: 'How can I sign up?',
    description:
      "Drop us an email at Sales@WeListSocial.com and we’ll get back to you next business day.",
  },
  {
    value: 'I’m not in Thailand, can I buy WeList?',
    description:
      "It’s possible to offer WeList in other countries, there are considerations like Language Support and Personal Data Protection compliance. It’s best to drop us an email to see if we can support your county Sales@WeListSocial.com.",
  },
  {
    value: 'Would WeList work for a real estate developer?',
    description:
      "It could depend on how you plan to use it and which features you want to leverage. Contact Sales for a consultation Sales@WeListSocial.com.",
  },
  {
    value: 'Why should I buy WeList?',
    description:
      "That’s easy, save tons of time and market like a pro, for less than you’d pay for an admin to try to keep up with WeList AI.",
  },
  {
    value: 'Can I have a discount?',
    description:
      "Discount? Ha, ha, ha. We are already super cheap for what we can do for your business. Nice try though.",
  },
  {
    value: 'I see other vendors offering websites cheaper.  Why is WeList more expensive?',
    description:
      <div className='flex flex-col'>
        <p>Many of these sites are normally stand-alone property listings sites. WeList is a robust, integrated and intelligent platform for your real estate business. When comparing other offerings things to check:</p>
        <div className='flex flex-col pl-4'>
          <p>- Is there some type of “lock-in” to their offering, things like your data is stored in their database and not easily available. With WeList your data is saved spreadsheets anytime you need it.</p>
          <p>- Do they offer you multilingual sites? Are they expecting you to enter every language or are they using inferior translation tools that sometimes give questionable results?</p>
          <p>- Is their back office secured with user roles?</p>
          <p>- Is their back office multi-user with agent segregation of data?</p>
          <p>- Do they require you to purchase advertising? </p>
          <p>- Do they have caps on the number of listings?</p>
          <p>- Do they charge for multi-user access?</p>
          <p>- Are they affiliated with web portals? Are your listings published on their platforms without your permission creating leads to their agents, rather to your own agents.</p>
          <p>- Do they offer social marketing integration? Is it just link publishing or is it true stand-alone posts?</p>
          <p>- Do they have referral agent features allowing your agents to collaborate without losing their clients to each other?</p>
          <p>- Do they offer connections and integrations with all the popular web portals, or are you locked in unless you want to retype listings and all the updates in those portals.</p>
          <p>- What are the additional options and what cost?</p>
          <p>- Do they offer lead management? Does it include leads not originating from your website?</p>
          <p>- Does it use LINE to facilitate communications between agents, agency and clients?</p>
          <p>- Can you create LINE groups to reach target communities, like Investors, Co-Agents, Agents?</p>
        </div>
        <p className='mt-2'>WeList it’s more than “just” a website. Before you commit your business to any platform, you need to consider what that platform is offering, normally the price is in keeping with the functionality you will get. If you are in doubt, our Sales Team is more than happy to offer you a free consultation contact us at Sales@WeListSocial.com</p>
      </div>
  },
  {
    value: 'Can I control what listings my agents post?',
    description:
      "Yes, you can. Just enable approvals, and you will be able to approve agent’s listings before they go live.",
  },
  {
    value: 'Will you raise the costs of my Subscription?',
    description:
      "We are committed to maintaining pricing affordable. We have no plans to increase pricing in Thailand. In the event that some service providers increase their pricing, we’ll let you know.",
  },
  {
    value: 'Are you planning new features? Will they cost me more?',
    description:
      "We have plans to add more functionality and AI capability to WeList. Some of these are enhancements to current modules, which are free to you. Other updates may be new modules. With new modules or add-ons, you’ll have the option to purchase them. It will be your choice if you want to opt into new modules/add-ons.",
  },
  {
    value: 'Where can I see what the back office looks like?',
    description:
      <p>The best way to see the back office is to watch our Quick Back Office Tour video <a className='text-[#019DA4] underline underline-offset-2' target='_blank' href='https://www.youtube.com/watch?v=O9jjDoW6u6M'>here</a>.</p>,
  },
  {
    value: 'I heard that WeList works with iConnect/iList. Is that correct?',
    description:
      "Yes, that's right. WeList can import and sync your iList listings. The sync is one way from iList to WeList. WeList does not update iList listings.",
  },
  {
    value: 'I heard that WeList works with Proppit. Is that correct?',
    description:
      "Yes, WeList can import your Proppit listings as well as update Proppit with changes from WeList in real time. You can also control which WeList listings that you want to send to Proppit. You can Boost and Superboost Proppit listings directly from WeList.",
  },
];

const FaqModal = () => {

  const items = groceries.map((item) => (
    <Accordion.Item key={item.value} value={item.value}>
      <Accordion.Control /*icon={item.emoji}*/>{item.value}</Accordion.Control>
      <Accordion.Panel>{item.description}</Accordion.Panel>
    </Accordion.Item>
  ));

  return (
    <div id="faq" className='w-full'>
        <div className='md:w-8/12 w-full max-w-[1600px] mx-auto py-10 sm:px-0 px-2'>
            <h2 className='welist-title mb-10  text-3xl text-center font-bold tracking-wider'>FAQ</h2>
            <div className='w-full flex flex-col'>
              <Accordion variant="contained" defaultValue="Apples">
                {items}
              </Accordion>
            </div>
          <div className='w-full flex items-center justify-center mt-4'>
                <SignUpForm title="I'm convinced, let's get started!" size='lg' bg='secondary' formType='faq' />
          </div>
        </div>
    </div>
  )
}

export default FaqModal